import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AnchorsListBlockData from '../../../Models/Content/AnchorsListBlockData';
import AnchorsTabs from './AnchorsTabs';

export default class AnchorsListBlock extends EpiComponent<AnchorsListBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
         <AnchorsTabs iContent={this.props.data} context={this.getContext()} />
        );
    }
}
